/**
 * What the signing UI should do with a WebAuthn challenge.
 * `choose` is the mixed case: an OTP-verified passkey exists (often on another
 * device) and this device also has settings passkeys that still need OTP.
 * Auto-prompting only the verified credential sends iOS to the cross-device QR.
 */
export const passkeyChallengeAction = ({
  allowCredentials,
  upgradeCredentials,
  forceVerifiedPasskey = false,
} = {}) => {
  const verified = Array.isArray(allowCredentials) && allowCredentials.length > 0;
  const unverified = Array.isArray(upgradeCredentials) && upgradeCredentials.length > 0;

  if (!verified && unverified) {
    return 'upgrade-only';
  }
  if (verified && unverified && !forceVerifiedPasskey) {
    return 'choose';
  }
  if (verified) {
    return 'authenticate';
  }
  return 'missing';
};

/** iOS ASAuthorizationError.canceled — RN may pass the raw Apple error string. */
const IOS_PASSKEY_CANCEL_PATTERN = /AuthorizationError error 1001|\berror 1001\b/i;

export const isPasskeyPromptCancelled = err => {
  if (!err) {
    return false;
  }
  if (err.name === 'NotAllowedError' || err.name === 'AbortError') {
    return true;
  }
  const message = typeof err.message === 'string' ? err.message : '';
  if (message === 'cancelled') {
    return true;
  }
  if (IOS_PASSKEY_CANCEL_PATTERN.test(message)) {
    return true;
  }
  return /canceled|cancelled/i.test(message);
};
